import React, { useEffect, useState } from 'react';
import styles from '../styles/wizards/AttachPlanToPlanWizard.scss';
import AddPlanIcon from '../assets/images/add-plan-60x60.svg';
import { __, setTableParams, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import { connect } from 'react-redux';
import AddExistingPlanForm from '../forms/add_existing_plan_form/AddExistingPlanForm';
import {
  attachPlanToPlanRevision,
  listPossiblePlanRevisionPlans,
} from '../redux/actions/table/current_set_plans';
import {
  attachPlanToPlanVersion,
  listPossiblePlanVersionPlans,
} from '../redux/actions/table/working_set_plans';
import { updateTool } from '../redux/actions/canvas_editor';

const AttachPlanToPlanWizard = ({
  match,
  current_set_plans,
  working_set_plans,
  onClose,
}) => {
  const [possiblePlans, setPossiblePlans] = useState([]);

  const plan_id =
    match.path === '/plans/versions/:plan_version'
      ? working_set_plans['is_edit']
      : current_set_plans['is_edit'];

  useEffect(() => {
    if (match.path === '/plans/versions/:plan_version') {
      listPossiblePlanVersionPlans(match.params.plan_version).then(
        ({ response }) => {
          const { is_edit, plan_title } = working_set_plans;
          setPossiblePlans([
            ...response.data,
            ...(is_edit ? [{ id: is_edit, title: plan_title }] : []),
          ]);
        }
      );
    }

    if (match.path === '/plans/revisions/:plan_revision') {
      listPossiblePlanRevisionPlans(match.params.plan_revision).then(
        ({ response }) => {
          const { is_edit, plan_title } = current_set_plans;
          setPossiblePlans([
            ...response.data,
            ...(is_edit ? [{ id: is_edit, title: plan_title }] : []),
          ]);
        }
      );
    }
  }, []);

  const _handleOnClose = (notification = true) => {
    notification && setNotification(__('wizard.attach-plan.confirm'));

    onClose();

    updateTool({ tool: 'hand' });
  };

  const handleSubmit = (formData) => {
    if (formData.plan_id == plan_id) {
      return _handleOnClose(false);
    }

    if (match.path === '/plans/revisions/:plan_revision') {
      return validateForm(
        attachPlanToPlanRevision(match.params.plan_revision, {
          ...formData,
          x: current_set_plans.x,
          y: current_set_plans.y,
          existing_plan_id: plan_id,
        }).then(({ response }) => {
          setTableParams('current_set_plans', {
            plan_id: response.data.id,
            x: current_set_plans.x,
            y: current_set_plans.y,
            old_plan_id: plan_id,
          });

          _handleOnClose();
        })
      );
    }

    if (match.path === '/plans/versions/:plan_version') {
      return validateForm(
        attachPlanToPlanVersion(match.params.plan_version, {
          ...formData,
          x: working_set_plans.x,
          y: working_set_plans.y,
          existing_plan_id: plan_id,
        }).then(({ response }) => {
          setTableParams('working_set_plans', {
            plan_id: response.data.id,
            x: working_set_plans.x,
            y: working_set_plans.y,
            old_plan_id: plan_id,
          });

          _handleOnClose();
        })
      );
    }
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('wizard.add-task.title.attach-plan')}</span>
          <span>{__('wizard.add-task.subtitle.attach-plan')}</span>
        </div>
        <div className={styles.right}>
          <AddPlanIcon />
        </div>
      </div>

      <div className={styles.body}>
        {possiblePlans && (
          <AddExistingPlanForm
            onSubmit={handleSubmit}
            possiblePlans={possiblePlans}
            onClose={onClose}
            initialValues={{ plan_id }}
          />
        )}
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    working_set_plans: state.table['working_set_plans'],
    current_set_plans: state.table['current_set_plans'],
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(subscribe(Localization, 'localization')(AttachPlanToPlanWizard))
);
